import { PS } from "./client-main";

PS.libsLoaded.loaded();
